import React, { useState } from "react";
import { Box, Button, Typography, TextField, Switch, FormControlLabel, Grid, Chip, Autocomplete } from "@mui/material";
import { PiPenNibLight } from "react-icons/pi";
import { PiRepeat } from "react-icons/pi";
import { MdMoreTime } from "react-icons/md";
import { CiImageOn } from "react-icons/ci";
import { BiCommentAdd } from "react-icons/bi";
import TaskCalendar from "../../task-calendar";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import axios from "axios";
import { useSelector } from "react-redux";

const types = ["daily", "weekly", "monthly"];
const activities = ["meeting", "traing", "workshop"];

const WeeklyActivityPlanner = ({ onClose }) => {
  const user = useSelector((state) => state.auth.user);
  const [plannedAppointments, setPlannedAppointments] = useState("");
  const [actualAppointments, setActualAppointments] = useState("");
  const [repeat, setRepeat] = useState("");
  const [startTime, setStartTime] = useState(() => {
    const now = new Date();
    return now.toTimeString().slice(0, 5); // Extracts HH:MM format
  });
  const [endTime, setEndTime] = useState(() => {
    const now = new Date();
    return now.toTimeString().slice(0, 5); // Extracts HH:MM format
  });
  const [allDay, setAllDay] = useState(false);
  const [plannedActivity, setPlannedActivity] = useState("");
  const [comment, setComment] = useState("");
  const today = new Date();
  const todayDate = today.toISOString().split("T")[0];
  const [currentDate, setCurrentDate] = useState(new Date()); // Current month and year
  const [selectedDate, setSelectedDate] = useState(new Date());

  // Handle month navigation
  const handlePrevMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1));
  };

  const handleNextMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1));
  };

  const handleDateClick = (date) => {
    if (date instanceof Date) {
      setSelectedDate(date); // Ensure it's a Date object
    } else {
      setSelectedDate(new Date(date)); // Fallback to create a Date object
    }
  };

  function getWeekOfMonth(dateString) {
    const date = new Date(dateString);
    const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const dayOfWeek = startOfMonth.getDay(); // Day of the week for the 1st of the month
    const adjustedDate = date.getDate() + dayOfWeek;
    return Math.ceil(adjustedDate / 7); // Calculate week number
  }

  const handleSave = async () => {
    const activityData = {
      date: selectedDate.toISOString().split("T")[0], // Format date as YYYY-MM-DD
      plannedAppointments,
      actualAppointments,
      repeatType: repeat,
      startTime,
      endTime,
      allDay,
      plannedActivity,
      comment,
      completed_by: user.username,
    };

    try {
      const response = await axios.post("/api/activity/activities", activityData);
      console.log("Activity created successfully:", response.data);
      onClose(); // Close the planner
    } catch (error) {
      console.error("Error creating activity:", error);
    }
  };

  return (
    <Box sx={{ p: 2, m: 2 }}>
      <Chip
        variant='contained'
        sx={{ fontSize: "14px", backgroundColor: "#F2F6FF", color: "#1751D0" }}
        label='Weekly Tasks'
      />

      {/* Header */}
      <Typography sx={{ fontSize: "24px", color: "black", fontWeight: "bold", mb: 1 }}>
        weekly Activity Planner
      </Typography>

      <Typography variant='subtitle2' sx={{ color: "#757575", mb: 1 }}>
        Date: {todayDate} &nbsp; • &nbsp; <span style={{ color: "#1751D0" }}>{user.username}</span>
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} lg={7}>
          <Typography variant='subtitle2' sx={{ color: "#757575", mb: 1 }}>
            <span style={{ fontSize: "20px", color: "#1751D0" }}>Week {getWeekOfMonth(selectedDate)}</span> &nbsp;
            &nbsp;{" "}
            {selectedDate?.toLocaleDateString("en-US", {
              weekday: "long",
              month: "long",
              day: "numeric",
              year: "numeric",
            })}
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography sx={{ fontSize: "16px" }}>
                <PiPenNibLight />
                Planned Appointments
              </Typography>
              <TextField
                fullWidth
                value={plannedAppointments}
                onChange={(e) => setPlannedAppointments(e.target.value)}
                sx={{ mb: 1 }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography sx={{ fontSize: "16px" }}>
                <PiPenNibLight />
                Actual Appointments Attend
              </Typography>
              <TextField
                fullWidth
                value={actualAppointments}
                onChange={(e) => setActualAppointments(e.target.value)}
                sx={{ mb: 1 }}
              />
            </Grid>

            <Grid item xs={4}>
              <Autocomplete
                id='type'
                options={types}
                value={repeat}
                onChange={(event, newValue) => setRepeat(newValue)}
                renderInput={(params) => (
                  <>
                    <Typography sx={{ fontSize: "16px", mb: 1 }}>
                      <PiRepeat />
                      Repeat
                    </Typography>
                    <TextField {...params} placeholder='Does not repeat' />
                  </>
                )}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <Typography sx={{ fontSize: "16px" }}>
                <MdMoreTime />
                Time
              </Typography>
              <Grid container spacing={2} alignItems='center'>
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    type='time'
                    value={startTime}
                    onChange={(e) => setStartTime(e.target.value)}
                    sx={{ mb: 2 }}
                    disabled={allDay}
                  />
                </Grid>
                <Grid item xs={1} textAlign='center'>
                  <ArrowRightAltIcon />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    type='time'
                    value={endTime}
                    onChange={(e) => setEndTime(e.target.value)}
                    sx={{ mb: 2 }}
                    disabled={allDay}
                  />
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={4}>
                  <FormControlLabel
                    control={<Switch checked={allDay} onChange={(e) => setAllDay(e.target.checked)} />}
                    label='All day'
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                id='activity'
                options={activities}
                value={plannedActivity}
                onChange={(event, newValue) => setPlannedActivity(newValue)}
                renderInput={(params) => (
                  <>
                    <Typography sx={{ fontSize: "16px" }}>
                      <CiImageOn />
                      Planned Activity
                    </Typography>
                    <TextField {...params} placeholder='Select Option' />
                  </>
                )}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <Typography sx={{ fontSize: "16px" }}>
                <BiCommentAdd />
                Comment
              </Typography>
              <TextField fullWidth multiline rows={3} value={comment} onChange={(e) => setComment(e.target.value)} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} lg={5}>
          <TaskCalendar
            currentDate={currentDate}
            selectedDates={[]}
            handlePrevMonth={handlePrevMonth}
            handleNextMonth={handleNextMonth}
            handleSelectedDatesUpdate={handleDateClick} // Pass the date click handler
          />
        </Grid>
      </Grid>

      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3, gap: 2 }}>
        <Button variant='outlined' onClick={onClose}>
          Close
        </Button>
        <Button variant='contained' onClick={handleSave}>
          Save
        </Button>
      </Box>
    </Box>
  );
};

export default WeeklyActivityPlanner;
